const CATALOG_LIST_BASE = "/app/catalog/list";

export const PROFILE_CATEGORY_SLUGS = {
  detran: "transporte-e-veiculos",
  cidadao: "servicos-ao-cidadao",
  servidor: "servidor-publico",
  empresa: "empresas",
  municipios: "municipios",
} as const;

export type ProfileCategoryKey = keyof typeof PROFILE_CATEGORY_SLUGS;

export function catalogListPath(slug: string): string {
  return `${CATALOG_LIST_BASE}/${slug}`;
}

/** Anexa sufixo `?municipio=&nome=` quando presente (home municipal). */
export function withMunicipalQuery(
  path: string,
  municipioQuerySuffix: string
): string {
  if (!municipioQuerySuffix) {
    return path;
  }
  return `${path}${municipioQuerySuffix}`;
}

export function profileListHref(
  key: ProfileCategoryKey,
  municipioQuerySuffix: string
): string {
  return withMunicipalQuery(
    catalogListPath(PROFILE_CATEGORY_SLUGS[key]),
    municipioQuerySuffix
  );
}

export function municipalQueryFromCodes(
  municipalityCode: number,
  municipalityName: string
): string {
  return `?municipio=${municipalityCode}&nome=${encodeURIComponent(
    municipalityName
  )}`;
}
